import { useCallback, useEffect } from 'react';
import { useSmartWallet } from '@package/smart-wallet/providers';
import * as Sentry from '@sentry/react';

type DisconnectProps =
  | {
      onSuccess: VoidFunction;
    }
  | undefined;

export const useDisconnectAccount = (props?: DisconnectProps) => {
  const { logout, isLoading, isConnected } = useSmartWallet();

  /* Callbacks */
  const handleDisconnect = useCallback(() => {
    try {
      if (isLoading || !isConnected) return;
      logout();
    } catch (error) {
      console.error('Error disconnecting: ', error);
      Sentry.captureException({
        message: 'Error disconnecting',
        extra: {
          error,
        },
      });
    }
  }, [isLoading, isConnected, logout]);

  /* Effects */
  useEffect(() => {
    if (!isLoading && !isConnected && props?.onSuccess) {
      props?.onSuccess?.();
    }
  }, [props, isConnected, isLoading]);

  /* Return */
  return { handleDisconnect, isLoading, isConnected };
};
